import gql from 'graphql-tag';

export const cardSideGroupCreate = gql`
  mutation cardSideGroupCreate($input: CardSideGroupCreateInput!) {
    cardSideGroupCreate(input: $input) {
      card_side_group {
        id
      }
    }
  }
`;

export const cardSideGroupUpdate = gql`
  mutation cardSideGroupUpdate($input: CardSideGroupUpdateInput!) {
    cardSideGroupUpdate(input: $input) {
      card_side_group {
        id
      }
    }
  }
`;

export const cardSideGroupsDelete = gql`
  mutation cardSideGroupsDelete($input: CardSideGroupsDeleteInput!) {
    cardSideGroupsDelete(input: $input) {
      success
    }
  }
`;
